import { ageLabel, badgeColor, readableText } from "../lib/teamBadge";

/* ───────────────────── TEAM BADGE ─────────────────────
   Circular team avatar: age-group label on a color-tinted disc. */
export function TeamBadge({ team, size = "md" }) {
  const bg = badgeColor(team);
  const fg = readableText(bg);
  const label = ageLabel(team);
  const dims = size === "lg"
    ? "w-14 h-14 text-base"
    : size === "sm"
      ? "w-8 h-8 text-[11px]"
      : "w-10 h-10 text-sm";
  // Light discs need a hairline border so they don't vanish on white cards.
  const border = fg === "#1f2937" ? "1px solid #e5e7eb" : "none";
  return (
    <div
      className={"rounded-full flex items-center justify-center font-bold flex-shrink-0 " + dims}
      style={{ backgroundColor: bg, color: fg, border }}
    >
      {label}
    </div>
  );
}
